import { OptionItem } from 'tno-core';

export const timeFrames = [
  new OptionItem('Today', 0),
  new OptionItem('24hrs', 1),
  new OptionItem('48hrs', 2),
  new OptionItem('All', 3),
];
